export default __webpack_public_path__ + "static/media/icono-logo-white.a32d864d.svg";